import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/check.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-52987374"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "seller-hero" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "seller-hero__content" }
const _hoisted_4 = { class: "seller-hero__left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "brand" }, "X-Global"),
  /*#__PURE__*/_createTextVNode(" — Бизнес без границ! ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, " Разместите товары и услуги – получайте заказы от покупателей, которые нам доверяют. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, " Прямые продажи, B2B маркетплейс, проверка контрагентов. Доверие и глобальные возможности для вашего бизнеса! ", -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = {
  key: 0,
  class: "primary-button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#authModal"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"seller-hero__right\" data-v-52987374><ul class=\"features-list\" data-v-52987374><li data-v-52987374><div class=\"circle\" data-v-52987374><img src=\"" + _imports_0 + "\" data-v-52987374></div> Бесплатно на старте </li><li data-v-52987374><div class=\"circle\" data-v-52987374><img src=\"" + _imports_0 + "\" data-v-52987374></div> Бейдж надежности </li><li data-v-52987374><div class=\"circle\" data-v-52987374><img src=\"" + _imports_0 + "\" data-v-52987374></div> Прямые сделки </li></ul></div>", 1)

import { computed } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'SellerHero',
  setup(__props) {

const store = useStore();
const loggedIn = computed(() => store.state.auth.status.loggedIn);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            (!loggedIn.value)
              ? (_openBlock(), _createElementBlock("button", _hoisted_9, " Начать продавать бесплатно "))
              : _createCommentVNode("", true),
            _hoisted_10
          ])
        ])
      ])
    ])
  ]))
}
}

})